export const ProductTypes = {
  CRUISE: "1", // 邮轮
  HOUTEL: "2", // 松赞
  CLUB: "3", // club
  LINE: "4", // 新东方
  STUDY: "5"
};
